/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Ask_NexyInputs */

const es_common_ask_nexy = /** @type {(inputs: Common_Ask_NexyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntale a Nexy...`)
};

const en_common_ask_nexy = /** @type {(inputs: Common_Ask_NexyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask Nexy...`)
};

/**
* | output |
* | --- |
* | "Ask Nexy..." |
*
* @param {Common_Ask_NexyInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const common_ask_nexy = /** @type {((inputs?: Common_Ask_NexyInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Ask_NexyInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_ask_nexy(inputs)
	return en_common_ask_nexy(inputs)
});
export { common_ask_nexy as "common.ask_nexy" }